export enum TaskImportance {
    IMPORTANT = 'IMPORTANT',
    NOT_IMPORTANT = 'NOT_IMPORTANT',
    VERY_IMPORTANT = 'VERY_IMPORTANT',
    ALL = 'ALL',
  }